import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { uiStore } from './store'
import { applyTheme } from './theme/theme'
import './theme/index.css'

// Apply the persisted theme before first paint to avoid a flash of light UI.
applyTheme(uiStore.getState().dark ? 'dark' : 'light')

const container = document.getElementById('root')
if (container === null) throw new Error('#root not found in index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
